module.exports = __webpack_public_path__ + "img/16.77310978.png";